// components/program-area.tsx
import Link from "next/link";
import ProgramSlider from "./slider/program-slider";
import { useTranslation } from "react-i18next";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";
import { ArrowIcons } from "../svg";

export default function ProgramArea() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="schools-area pb-70 grey-bg z-1 position-relative">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="tp-program-wrap wow fadeInUp" data-wow-delay=".3s">
              <div className="tp-section text-center mb-30">
                <h2 className="tp-section-title mb-20">
                  {t("program_title_prefix")}{" "}
                  <span>{t("program_title_highlight")}</span>
                </h2>
                <p>{t("program_subtitle")}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <ProgramSlider />
          </div>
          <div className="col-12">
            <div className="tp-program-dot text-center"></div>
          </div>
          <div className="col-12">
            <div className="tp-program-all text-center">
              <p>
                <Link
                  aria-label="View All Schools"
                  href={getLocalizedPath("/htu-schools", language)}
                >
                  {t("program_view_all_schools")}{" "}
                  <span>
                    {ifArabic(
                      <ArrowIcons.LeftSmArrowThree />,
                      <ArrowIcons.RightSmArrowThree />
                    )}
                  </span>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
